module.exports = __webpack_public_path__ + "img/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 2.6177fc41.webp";